export const hoaDon = {
  sections: {
    list: { title: 'Hóa đơn' },
    detail: { title: 'Chi tiết hóa đơn' },
  },
  lineList: {
    title: 'Hóa đơn chi tiết hàng',
    tabInvoices: 'Hóa đơn',
    tabLines: 'Chi tiết hàng',
    summary: 'Tổng {count} dòng hàng',
    noData: 'Không có dữ liệu',
    columns: {
      maHoaDon: 'Mã hóa đơn',
      thoiGian: 'Thời gian',
      trangThai: 'Trạng thái',
      chiNhanh: 'Chi nhánh',
      nguoiBan: 'Người bán',
      maKhachHang: 'Mã KH',
      tenKhachHang: 'Tên khách hàng',
      maHangHoa: 'Mã hàng',
      tenHangHoa: 'Tên hàng',
      donViTinh: 'ĐVT',
      soLuong: 'Số lượng',
      tongCanNang: 'Số cân (kg)',
      tongTheTich: 'Số khối (m³)',
      donGia: 'Đơn giá',
      giamGia: 'Giảm giá dòng',
      giaBan: 'Giá bán',
      thanhTien: 'Thành tiền',
      giamGiaChung: 'Giảm giá chung',
      thuKhacChung: 'Thu khác',
      tongCong: 'Tổng cộng',
      ghiChu: 'Ghi chú',
    },
  },
  titles: { add: 'Thêm hóa đơn' },
  tabs: {
    banNhanh: 'Bán nhanh',
    banThuong: 'Bán thường',
    banGiaoHang: 'Bán giao hàng',
  },
  columns: {
    code: 'Mã',
    summary: 'Thông tin',
    status: 'Trạng thái',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
  },
  filter: { searchPlaceholder: 'Tìm theo mã hóa đơn...' },
  filters: {
    maKhachHang: 'Mã khách hàng',
    tenKhachHang: 'Tên khách hàng',
    all: 'Tất cả',
    fromDate: 'Từ ngày',
    toDate: 'Đến ngày',
    dateRange: 'Khoảng thời gian',
    dateRangePlaceholder: 'Chọn khoảng ngày',
    status: 'Trạng thái',
    statusSection: 'Trạng thái hóa đơn',
    dateSection: 'Thời gian',
    thoiGianBan: 'Thời gian bán',
    thoiGianTao: 'Thời gian tạo',
    salesSection: 'Bán hàng',
    peopleSection: 'Người dùng',
    seller: 'Người bán',
    deliverySection: 'Giao hàng',
    deliveryPartner: 'Đối tác giao hàng',
    deliveryArea: 'Khu vực giao hàng',
    deliveryStatus: 'Trạng thái giao hàng',
    otherIncomeType: 'Loại thu khác',
    maHang: 'Mã hàng',
    tenHang: 'Tên hàng',
    textDetailTitle: 'Bộ lọc hóa đơn',
    khachHangPlaceholder: 'Tìm khách hàng',
    loaiBanOnline: 'Loại bán online',
    loaiBanOnlineOnline: 'Đơn online',
    loaiBanOnlineBanGop: 'Bán gộp',
    sortField: 'Sắp xếp theo',
    sortDir: 'Thứ tự',
    sortThoiGian: 'Thời gian bán',
    sortThoiGianTao: 'Thời gian tạo',
    sortMaHoaDon: 'Mã hóa đơn',
    sortKhachCanTra: 'Khách cần trả',
    sortTongTienHang: 'Tổng tiền hàng',
  },
  form: {
    code: 'Mã hóa đơn',
    codeAuto: 'Để trống tự sinh mã',
    time: 'Thời gian',
    invoiceType: 'Loại hóa đơn',
    saleType: 'Hình thức bán',
    typeNoDelivery: 'Không giao hàng',
    typeDelivery: 'Giao hàng',
    customer: 'Khách hàng',
    customerSearch: 'Tìm khách hàng (F4)',
    customerQuickAdd: 'Thêm nhanh khách hàng',
    customerQuickEdit: 'Sửa khách hàng',
    congNoHienTai: 'Công nợ',
    congNoKhachNo: 'Khách nợ',
    congNoNoKhach: 'Nợ khách',
    retailCustomer: 'Khách lẻ',
    bangGia: 'Bảng giá',
    bangGiaDefault: 'Bảng giá chung',
    tabLines: 'Chi tiết hàng hóa',
    note: 'Ghi chú',
    pickupAddress: 'Địa chỉ lấy hàng',
    pickupAddressPlaceholder: 'Chọn địa chỉ lấy hàng',
    pickupAddressEmpty: 'Chưa có địa chỉ lấy hàng',
    pickupAddressQuickAdd: 'Thêm nhanh địa chỉ lấy hàng',
    channel: 'Kênh bán',
    seller: 'Người bán',
    saleTime: 'Thời gian bán',
    creator: 'Người tạo',
    createdAt: 'Thời gian tạo',
    discount: 'Giảm giá (đ)',
    discountShort: 'Giảm giá',
    vat: 'Thuế GTGT (VAT)',
    lines: 'Chi tiết hàng',
    danhSachChiTiet: 'Danh sách chi tiết',
    addLine: 'Thêm dòng',
    addPriceLine: 'Thêm dòng giá',
    product: 'Hàng hóa',
    maHang: 'Mã hàng',
    productName: 'Tên hàng',
    productSearch: 'Tìm mã / tên hàng',
    quickSearch: 'Tìm hàng hóa (F3)',
    qty: 'SL bán',
    unitPrice: 'Đơn giá',
    salePrice: 'Giá bán',
    lineTotal: 'Thành tiền',
    editPrice: 'Sửa giá bán',
    priceBelowCost: 'Cảnh báo: đơn giá thấp hơn giá vốn',
    currency: 'VND',
    byAmount: 'Theo số tiền',
    byPercent: 'Theo %',
    unit: 'ĐV quy đổi',
    unitFactor: 'Hệ số',
    convertedQty: 'SL quy đổi',
    lastPrice: {
      label: 'Giá gần nhất',
      never: 'Khách hàng chưa mua hàng này',
      invoice: 'Hóa đơn',
      qty: 'Số lượng',
      unitPrice: 'Đơn giá',
      discount: 'Giảm giá',
      applyHint: 'Bấm để áp dụng giá này cho dòng hàng',
      unitMismatch: 'Khác đơn vị tính đang bán — đổi ĐVT để áp dụng',
    },
    posTable: {
      stt: '# (Số thứ tự)',
      action: '+ (Thêm dòng giá / Xóa)',
      groupEdge: 'Cột số thứ tự / thao tác',
      sellUnit: 'Đơn vị tính bán',
      sellQty: 'Số lượng bán',
      sellUnitPrice: 'Đơn giá bán',
      sellDiscount: 'Giảm giá bán',
      sellPrice: 'Giá bán',
      sellTotal: 'Thành tiền bán',
      baseUnit: 'Đơn vị tính cơ bản',
      conversionRate: 'Tỷ lệ quy đổi',
      conversionRateHint: '1 đơn vị tính bán = Tỷ lệ × đơn vị tính cơ bản',
      baseQty: 'Số lượng cơ bản',
      basePrice: 'Giá bán cơ bản',
      baseTotal: 'Thành tiền cơ bản',
      groupSell: 'Thông tin bán',
      groupBase: 'Quy đổi đơn vị cơ bản',
      columnSettings: 'Cấu hình cột',
      resetColumns: 'Khôi phục mặc định',
      lockedColumn: 'Cột bắt buộc',
    },
    discountPercent: 'Giảm (%)',
    lineNote: 'Ghi chú dòng',
    stock: 'Tồn',
    comboParts: 'Thành phần',
    comboBadge: 'Combo',
    stockSystemTitle: 'Tồn kho toàn hệ thống',
    lineAmount: 'Thành tiền',
    delivery: 'Thông tin giao hàng',
    savedAddress: 'Thông tin giao hàng đã lưu',
    savedAddressPlaceholder: 'Chọn thông tin giao hàng',
    savedAddressEmpty: 'Chưa có thông tin giao hàng nào đã lưu',
    savedAddressQuickAdd: 'Thêm nhanh thông tin giao hàng',
    recipient: 'Người nhận hàng',
    phone: 'SĐT người nhận',
    address: 'Địa chỉ giao hàng',
    area: 'Tỉnh/Thành',
    ward: 'Phường/Xã',
    areaEmpty: '— Chọn tỉnh/thành —',
    wardEmpty: '— Chọn phường/xã —',
    deliveryPartner: 'Đối tác giao hàng',
    serviceType: 'Loại dịch vụ',
    trackingCode: 'Mã vận đơn',
    shippingPanelTitle: 'Vận chuyển',
    deliveryPartnerShort: 'Đối tác',
    serviceTypeShort: 'Dịch vụ',
    trackingCodeShort: 'Mã VĐ',
    appliedFeeShort: 'Phí',
    deliveryStatusShort: 'Trạng thái',
    feeNeedAddressHint: 'Chọn tỉnh/phường',
    packageCount: 'Số kiện',
    dimensions: 'Kích thước',
    dimLength: 'Dài',
    dimWidth: 'Rộng',
    dimHeight: 'Cao',
    dimUnit: 'Đơn vị kích thước',
    measureUnit: 'Đơn vị',
    weight: 'Trọng lượng',
    shippingFee: 'Phí giao hàng',
    appliedFee: 'Phí áp dụng',
    cod: 'Thu hộ (COD)',
    deliveryNote: 'Ghi chú cho bưu tá',
    deliveryTime: 'Hạn giao hàng',
    latestDeliveryTime: 'Hạn giao hàng',
    /** Nút đưa thời gian bán / hạn giao về chuẩn (now / bán+3h). */
    deliveryTimeDefault: 'Mặc định',
    deliveryStatus: 'Trạng thái giao hàng',
    payment: 'Thanh toán',
    addPayment: 'Thêm thanh toán',
    paymentMethod: 'Phương thức',
    amount: 'Số tiền',
    paymentNote: 'Ghi chú',
    otherFee: 'Thu khác',
    addOtherFee: 'Thêm thu khác',
    thuKhacSeeMore: 'Xem thêm ({count})',
    thuKhacCollapse: 'Thu gọn',
    category: 'Danh mục',
    value: 'Giá trị',
    percent: 'Phần trăm',
    noCategory: 'Chưa có danh mục thu khác nào',
    customerInfo: 'Thông tin khách hàng',
    package: 'Gói hàng',
    shippingFeeSection: 'Phí vận chuyển',
    codToggle: 'Thu hộ tiền (COD)',
    codAmount: 'Số tiền thu hộ',
    shippingViaPartner: 'Cổng KiotViet',
    shippingSelf: 'Giao hàng',
    shippingPartners: 'Đối tác vận chuyển của KiotViet',
    shippingGatewayHint:
      'Nhập địa chỉ đầy đủ để hệ thống tính phí và gợi ý đối tác vận chuyển phù hợp.',
    discountType: 'Loại giảm giá',
    discountValue: 'Giá trị giảm',
    orderNote: 'Ghi chú đơn hàng',
  },
  popup: {
    thuKhac: {
      title: 'Các khoản thu khác',
      maThuKhac: 'Mã',
      loaiThu: 'Loại thu / Chi phí khác',
      ghiChu: 'Ghi chú',
      ghiChuPlaceholder: 'Phí này là gì…',
      mucThu: 'Mức thu',
      thu: 'Thu',
      applyMucThuHint: 'Bấm để áp mức danh mục vào cột Thu',
      hint: 'Mức thu lấy từ danh mục. Nhập số tiền ở cột Thu (> 0) mới ghi nhận. Bấm mức thu để điền nhanh.',
      total: 'Tổng',
    },
  },
  messages: {
    loadError: 'Không tải được danh sách hóa đơn.',
    deleteSuccess: 'Đã xóa hóa đơn.',
    createSuccess: 'Đã tạo hóa đơn.',
    updateSuccess: 'Đã cập nhật hóa đơn.',
    capNhatConfirm: {
      title: 'Cập nhật hóa đơn',
      intro: 'Khi thay đổi thông tin trên hóa đơn, hệ thống sẽ:',
      item1: 'Hủy hóa đơn cũ và tạo hóa đơn mới',
      item1VanHanh:
        'Nếu đổi mặt hàng / số lượng: hủy hóa đơn cũ, tạo hóa đơn mới và kho xử lý lại từ đầu. Nếu chỉ sửa thông tin: giữ nguyên mã hóa đơn',
      khoDangXuLy: 'Đơn đang được kho xử lý',
      khoChanSuaHang:
        'Kho đã bắt đầu nhặt đơn — không thể thêm/xóa sản phẩm hoặc đổi số lượng. Vẫn được sửa giá, giảm giá, khách hàng, giao hàng, ghi chú.',
      khoSuaThongTin:
        '• Chỉ sửa thông tin (giá, giảm giá, khách hàng, giao hàng, ghi chú...): hóa đơn giữ nguyên mã, kho nhận thông báo và làm tiếp.',
      khoDoiHang:
        '• Đổi mặt hàng hoặc số lượng: sẽ bị chặn — cần kho Hủy thao tác (reset về trước Đang nhặt) trước, sau đó sửa sẽ tạo hóa đơn mới để kho làm lại.',
      item1KhongSinhDuoi:
        'Chỉ sửa thông tin không ảnh hưởng tồn (giá, giảm giá, khách, giao hàng…): giữ nguyên mã hóa đơn, không tạo bản đuôi',
      item2: 'Tất cả các phiếu thanh toán của hóa đơn cũ sẽ được gán với hóa đơn mới',
      item3: 'Nếu bạn thay đổi số lượng hàng hóa, cần đảm bảo tồn kho của cửa hàng vẫn đáp ứng đủ, hệ thống sẽ không kiểm tra lại.',
      question: 'Bạn có muốn tiếp tục?',
      dongY: 'Đồng ý',
      boQua: 'Bỏ qua',
    },
    needLines: 'Vui lòng thêm ít nhất một dòng hàng.',
    needKhachHang: 'Vui lòng chọn khách hàng.',
    validateThoiGianGiaoBeforeThoiGian:
      'Thời gian giao hàng không được trước thời gian tạo đơn/hóa đơn.',
    deliveryTimeBeforeNow: 'Hạn giao hàng mới không được trước thời điểm hiện tại.',
    thoiGianGiaoDichLocked: 'Không được thay đổi thời gian giao dịch theo cài đặt hệ thống.',
    thoiGianGiaoDichOutOfRange: 'Thời gian giao dịch nằm ngoài khoảng ngày được phép.',
    invalidDienThoaiNguoiNhan: 'Số điện thoại người nhận không hợp lệ (8–15 chữ số).',
    invalidTrongLuong: 'Trọng lượng phải là số không âm.',
    invalidKichThuoc: 'Kích thước (dài/rộng/cao) phải là số không âm.',
    warnStockCost: 'Cảnh báo tồn/giá vốn: {detail}',
    noData: 'Không có hóa đơn.',
    noLines: 'Không có dòng hàng.',
    listSummary: 'Tổng {count} hóa đơn',
    confirmDelete: 'Xóa hóa đơn {name}?',
    favoriteSuccess: 'Đã cập nhật yêu thích.',
    saoChepSuccess: 'Đã sao chép hóa đơn.',
    statusSuccess: 'Đã cập nhật trạng thái hóa đơn.',
    confirmKetThuc:
      'Kết thúc hóa đơn {name}? Trạng thái sẽ được cập nhật thành Hoàn thành.',
    confirmHuy:
      'Hủy hóa đơn {name}? Trạng thái sẽ được cập nhật thành Đã hủy.',
    confirmHuySelected:
      'Hủy {count} hóa đơn đã chọn? Trạng thái sẽ được cập nhật thành Đã hủy. Các hóa đơn đã hủy / hoàn thành / đã chốt sẽ được bỏ qua.',
    confirmHuyDaThu:
      'Hóa đơn {name} khách đã trả {soTien}. Hủy hóa đơn sẽ không tự hoàn tiền và khoản này không còn tính vào công nợ — cần hoàn tiền cho khách hoặc ghi nhận lại thủ công. Vẫn hủy?',
    huySelectedSuccess: 'Đã hủy {ok}/{total} hóa đơn.',
    huySelectedPartial: 'Đã hủy {ok}/{total} hóa đơn. {fail} hóa đơn lỗi / không hủy được.',
    huySelectedNone: 'Không có hóa đơn nào trong lựa chọn có thể hủy.',
    paySuccess: 'Đã ghi nhận thanh toán.',
    invalidPayAmount: 'Số tiền thanh toán không hợp lệ.',
    importSuccess: 'Nhập hóa đơn thành công.',
    importDescription:
      'Tải mẫu (không cần mã HĐ / kênh bán). Thời gian trống = hiện tại, người bán = bạn. Gộp dòng cùng khách hàng liên tục thành một hóa đơn; cùng khách nhưng bị cách dòng thì tách.',
    importWillCreate: 'Sẽ tạo {count} hóa đơn từ file đã chọn.',
    importPreviewProgress: 'Xem trước {current}/{total}',
    importPreviewStopped: 'Đã dừng xem trước.',
    importPreviewDone: 'Đã xem trước xong {done}/{total} hóa đơn.',
    importPreviewLoading: 'Đang chuẩn bị hóa đơn {current}/{total}…',
    phieuXuatKhoFromInvoice: 'Xuất bán theo hóa đơn {code}',
    traHangNeedPhieuXuatKho: 'Cần có phiếu xuất kho trước khi trả hàng.',
    traHangDaTraHet: 'Đã trả hết đơn — không thể trả thêm.',
  },
  actions: {
    pay: 'Thanh toán',
    favorite: 'Yêu thích',
    changeStatus: 'Đổi trạng thái',
    print: 'In',
    printHoaDon: 'In hóa đơn',
    exportExcelHoaDon: 'Xuất Excel',
    printNhiet: 'In phiếu giao hàng',
    exportFile: 'Xuất file',
    dieuChinhCot: 'Điều chỉnh cột',
    traHang: 'Trả hàng',
    taoPhieuXuatKho: 'Tạo phiếu xuất kho',
    phieuXuatKho: 'Phiếu xuất',
    saoChep: 'Sao chép',
    copy: 'Sao chép',
    taoYeuCau: 'Tạo YC xuất VAT',
    taoYeuCauSelected: 'Tạo YCXHD ({count})',
    taoYeuCauMenu: 'Tạo YCXHD',
    printSelected: 'In đơn ({count})',
    printMenu: 'In đơn',
    huySelected: 'Hủy ({count})',
    huyMenu: 'Hủy',
    bulkSelected: 'Thao tác ({count})',
    ketThuc: 'Kết thúc',
    taoDatHang: 'Tạo đặt hàng',
    capNhat: 'Cập nhật',
    dongY: 'Đồng ý',
    xuLyDonHang: 'Xử lý đơn hàng',
    huyBo: 'Hủy bỏ',
  },
  fields: {
    maKhachHang: 'Mã khách hàng',
    nhanVienPhuTrach: 'NVKD phụ trách khách',
    soSanPham: 'Tổng số sản phẩm',
    soLuongSanPham: 'Tổng số lượng SP',
    tongCanNang: 'Tổng số cân (kg)',
    tongTheTich: 'Tổng số khối (m³)',
    maHoaDon: 'Mã hóa đơn',
    maPhieuTraHang: 'Mã trả hàng',
    maPhieuXuatKho: 'Phiếu xuất kho',
    maPhieuNhapKho: 'Phiếu nhập kho',
    maDatHang: 'Mã đặt hàng',
    maYeuCauSuaChua: 'Mã yêu cầu sửa chữa',
    maYeuCauXuatHoaDon: 'Mã yêu cầu xuất hóa đơn',
    nguoiTao: 'Người tạo đơn',
    nguoiTaoHeThong: 'Hệ thống',
    tenKhachHang: 'Tên khách hàng',
    khachHang: 'Khách hàng',
    kenhBan: 'Kênh bán',
    ngayDatHang: 'Ngày giờ đặt hàng',
    thoiGianBan: 'Thời gian bán',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    thoiGian: 'Ngày giờ',
    bangGia: 'Bảng giá',
    trangThai: 'Trạng thái',
    chiNhanhXuLy: 'Chi nhánh xử lý',
    chiNhanhTao: 'Chi nhánh tạo',
    nguoiNhanDat: 'Người bán',
    kichThuoc: 'Kích thước',
    thuHoTienShort: 'Thu hộ tiền',
    hinhThucGiao: 'Hình thức giao',
    diaChiLayHang: 'Địa chỉ lấy hàng',
    nguoiNhan: 'Tên người nhận',
    dienThoai: 'Số điện thoại',
    diaChi: 'Địa chỉ',
    khuVuc: 'Khu vực',
    phuongXa: 'Phường/Xã',
    soKien: 'Số kiện',
    trongLuong: 'Trọng lượng',
    donViTrongLuong: 'Đơn vị trọng lượng',
    chieuDai: 'Chiều dài',
    chieuRong: 'Chiều rộng',
    chieuCao: 'Chiều cao',
    donViKichThuoc: 'Đơn vị kích thước',
    dichVu: 'Dịch vụ giao hàng',
    nguoiGiaoDoiTac: 'Người giao / Đối tác giao',
    thuHoTien: 'Thu hộ tiền (COD)',
    soTienCod: 'Số tiền COD',
    phiTraDTGH: 'Phí trả ĐTGH',
    thoiGianGiaoHang: 'Hạn giao hàng',
    ghiChuGiaoHang: 'Ghi chú giao hàng',
    ghiChuChoBuuta: 'Ghi chú cho bưu tá',
    tongTienHang: 'Tổng tiền hàng',
    giamGia: 'Giảm giá',
    thuKhac: 'Thu khác',
    khachCanTra: 'Khách cần trả',
    khachThanhToan: 'Khách thanh toán',
    tienThua: 'Tiền thừa',
    khachDaTra: 'Đã thanh toán',
    tongSauGiamGia: 'Tổng sau giảm giá',
    nguoiBan: 'Người bán',
    loaiHoaDon: 'Loại hóa đơn',
    hinhThucBan: 'Hình thức bán',
    trangThaiGiaoHang: 'Trạng thái giao hàng',
    yeuThich: 'Yêu thích',
    ghiChu: 'Ghi chú đơn hàng',
    giamGiaHoaDon: 'Giảm giá hóa đơn',
    phiShip: 'Phí ship',
    chiNhanh: 'Chi nhánh',
    maVanDon: 'Mã vận đơn',
    totalAmount: 'Tổng tiền',
    paidAmount: 'Đã thanh toán',
    payAmount: 'Số tiền thanh toán',
    paymentMethod: 'Phương thức thanh toán',
    actions: 'TT',
  },
  aria: {
    columnPicker: 'Chọn cột hiển thị',
    toggleStar: 'Đánh dấu yêu thích',
    selectAllPage: 'Chọn tất cả hàng trên trang này',
    selectRow: 'Chọn hàng',
  },
  detailTabs: {
    chung: 'Chung',
    generalInfo: 'Thông tin',
    chiTietDonHang: 'Chi tiết đơn hàng',
    khoFlow: 'Luồng kho',
  },
  khoFlow: {
    trangThai: 'Trạng thái vận hành',
    chuaToi: 'Chưa tới bước này',
    empty: 'Hóa đơn chưa vào luồng xử lý kho.',
  },
  summary: {
    tongTienHangCount: 'Tổng tiền hàng ({count})',
    tongSoLuong: 'Tổng số lượng',
    tongTienHang: 'Tổng tiền hàng',
    giamGiaPhieuDat: 'Giảm giá',
    tongCong: 'Tổng cộng',
    hangSuaChua: 'Hàng sửa chữa',
    maHangDeLai: 'Mã hàng để lại',
    capSuaChua: 'Cặp {stt}',
  },
  paymentMethod: {
    TIEN_MAT: 'Tiền mặt',
    THE: 'Thẻ',
    VI: 'Ví',
    CHUYEN_KHOAN: 'Chuyển khoản',
  },
  status: {
    DANG_XU_LY: 'Đang xử lý',
    HOAN_THANH: 'Hoàn thành',
    KHONG_GIAO_DUOC: 'Không giao được',
    DA_HUY: 'Đã hủy',
    DA_HUY_DO_CHINH_SUA: 'Đã hủy do chỉnh sửa',
  },
  deliveryStatus: {
    CHO_XU_LY: 'Chờ xử lý',
    CHO_LAY_HANG: 'Chờ lấy hàng',
    DANG_GIAO: 'Đang giao',
    DA_GIAO: 'Đã giao',
    GIAO_THAT_BAI: 'Giao thất bại',
    PHAT_KHONG_THANH_CONG: 'Phát không thành công',
    DANG_TRA_HANG: 'Đang trả hàng',
    TRA_HANG: 'Trả hàng',
    HUY: 'Hủy',
  },
  placeholders: {
    formTitle: 'Tạo / sửa hóa đơn',
    formBody: 'Biểu mẫu đầy đủ sẽ được bổ sung. Có thể dùng import Excel từ API khi cần.',
    ghiChu: 'Ghi chú...',
    ghiChuGiao: 'Ghi chú giao...',
    chonDoiTac: 'Chọn đối tác...',
  },
  pos: {
    tabNew: 'Hóa đơn mới',
    newTabHoaDon: 'Hóa đơn mới',
    newTabTraHang: 'Trả hàng mới',
    tabEdit: 'Sửa {code}',
    tabClone: 'Bản sao {code}',
    tabTitle: 'Hóa đơn {n}',
    switchToDatHang: 'Chuyển sang Đặt hàng',
    switchToHoaDon: 'Chuyển sang Hóa đơn',
    tabFromDatHang: 'HĐ mới · từ {code}',
    tabFromYeuCauSuaChua: 'HĐ mới · từ {code}',
    addTab: 'Thêm hóa đơn',
    history: 'Lịch sử hóa đơn',
    confirmCloseTitle: 'Đóng tab này?',
    confirmCloseBody: 'Tab có thay đổi chưa lưu. Đóng tab sẽ mất các thay đổi chưa lưu.',
    openEdit: 'Mở tab sửa',
    openClone: 'Nhân bản',
    saved: 'Đã lưu hóa đơn.',
  },
}
